export default function ExpertArticle() {
  return (
    <section id="expert" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 text-center">
            Почему большинство техник работы с возражениями не работают
          </h2>
          <p className="text-lg text-gray-600 text-center mb-12 leading-relaxed">
            Компании тратят десятки тысяч на обучение, но результата нет. Вот почему.
          </p>

          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm mb-10">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Типичные ошибки в обучении</h3>
            <div className="space-y-4">
              {[
                'Менеджеры учат шаблонные ответы, которые клиенты слышат от всех конкурентов',
                'Сотрудники пытаются «победить» клиента вместо того, чтобы помочь ему принять решение',
                'Тренинги учат спорить и доказывать, что вызывает отторжение',
                'Продают цену вместо ценности — и при первом возражении сразу снижают стоимость',
                'Скрипты используются без понимания психологии клиента и контекста разговора',
                'Обучение ограничивается теорией: нет практики на реальных ситуациях компании',
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-red-500 text-sm"></i>
                  </div>
                  <p className="text-gray-700 leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-600 rounded-2xl p-8 md:p-10 text-white mb-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center">Мой подход к работе с возражениями</h3>
            <div className="text-center mb-8">
              <p className="text-xl md:text-2xl font-semibold mb-2">
                Возражение — это не отказ.
              </p>
              <p className="text-lg text-white/90">
                Это сигнал, что клиенту не хватает информации, доверия, ценности или уверенности.
              </p>
            </div>

            <div className="grid sm:grid-cols-5 gap-4 mb-8">
              {[
                { step: '1', title: 'Понять истинную причину' },
                { step: '2', title: 'Уточнить ситуацию' },
                { step: '3', title: 'Показать ценность' },
                { step: '4', title: 'Закрыть сомнение' },
                { step: '5', title: 'Перевести разговор дальше' },
              ].map((item, i) => (
                <div key={i} className="bg-white/15 rounded-xl p-4 text-center backdrop-blur-sm border border-white/20 relative">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-2 text-sm font-bold">
                    {item.step}
                  </div>
                  <p className="text-sm font-semibold leading-snug">{item.title}</p>
                  {i < 4 && (
                    <div className="hidden sm:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-white/70 text-lg"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="bg-white/10 rounded-xl p-6 text-center border border-white/20">
              <p className="text-lg font-semibold">
                Мы не учим «отбивать» возражения. Мы учим помогать клиенту принимать решение.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}